export const properties = {
    MESSAGE_LIST: {
        LOGOUT_MSG: "You have been logged out from Global Tradeshow Solution. Please login to continue.",
        DEVICE_ASSIGN_ERROR_MSG: "An error occurred while assigning the device. Please try again.",
        DEVICE_RELEASE_ERROR_MSG: "An error occurred while releasing the device. Please try again.",
        DEVICE_NOT_FOUND: "An error occurred while fetching devices. Please select the loaction and try again.",
    },
}
